import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ProfileService } from '../profile.service';
import { map } from 'rxjs/operators';
import { Country } from '../types/countries';

@Component({
  selector: 'lp2-mobile-tools',
  templateUrl: './mobile-tools.component.html',
  styleUrls: ['./mobile-tools.component.scss'],
})
export class MobileToolsComponent {
  isCollapsed = true;
  @Input() isCollapsible = true;
  @Output() collapseChange = new EventEmitter();

  @Input()
  get collapse() {
    return this.isCollapsed;
  }

  set collapse(isCollapsed) {
    this.isCollapsed = isCollapsed;
    this.collapseChange.emit(this.isCollapsed);
  }

  showTranslator$ = this.profileService.address$.pipe(map(({countryISO}) => countryISO !== Country.VIETNAM));

  constructor(private readonly profileService: ProfileService) {}

  toggle() {
    this.collapse = !this.collapse;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-tools/mobile-tools.component.ts